var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExcelIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none",
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.08 2.379h-7.42v-.515a.97.97 0 0 0-.39-.784.97.97 0 0 0-.862-.158l-11.76 3.4a.98.98 0 0 0-.708.941v17.471c0 .434.292.821.708.942l11.76 3.4q.137.039.275.038a.97.97 0 0 0 .586-.197.97.97 0 0 0 .391-.783v-.515h7.42c.54 0 .98-.44.98-.98V3.359c0-.54-.44-.98-.98-.98m-8.26 23.755c0 .06-.035.096-.055.112a.14.14 0 0 1-.123.022l-11.76-3.4a.14.14 0 0 1-.102-.134V5.264a.14.14 0 0 1 .101-.135l11.76-3.4a.14.14 0 0 1 .124.023c.02.015.055.05.055.112zm8.4-1.495c0 .076-.064.14-.14.14h-7.42v-1.96h4.9a.42.42 0 1 0 0-.84h-4.9v-2.52h4.9a.42.42 0 1 0 0-.84h-4.9v-2.52h4.9a.42.42 0 1 0 0-.84h-4.9v-2.52h4.9a.42.42 0 1 0 0-.84h-4.9v-2.52h4.9a.42.42 0 1 0 0-.84h-4.9v-2.52h4.9a.42.42 0 1 0 0-.84h-4.9v-1.96h7.42c.076 0 .14.064.14.14zm-12.282-9.106a.42.42 0 1 1-.593.595l-1.524-1.516-1.426 1.624a.419.419 0 1 1-.631-.554l1.46-1.664-1.56-1.554a.42.42 0 1 1 .592-.595l1.524 1.517 1.426-1.624a.42.42 0 1 1 .63.554l-1.46 1.663z"
})));
export { SvgExcelIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/excel-icon.svg";